<ion-grid class="tip-grid">
    <ion-row class="ion-justify-content-center">
        <ion-col *ngFor="let percent of defaults" [sizeXs]="xsCol" [sizeMd]="medCol">
            <ion-button class="selection-option"
                        [color]="this.selectedTip === percent ? 'primary' : 'tertiary'"
                        (click)="changedSelected(percent)">
                <div class="option-container">
                    <span>{{ percent.percent }}%</span>
                    <span class="dollar-summary">{{ percent.value | currency }}</span>
                </div>
            </ion-button>
        </ion-col>

        <ion-col *ngIf="showMax" [sizeXs]="xsCol" [sizeMd]="medCol">
            <ion-button class="selection-option"
                        [color]="this.selectedTip === 'MAX' ? 'primary' : 'tertiary'"
                        (click)="changedSelected('MAX')">
                <div class="option-container">
                    <span>Max</span>
                    <span class="dollar-summary">{{ max | currency }}</span>
                </div>
            </ion-button>
        </ion-col>
    </ion-row>
    <ion-row>
        <ion-col size-xs="6">
            <ion-button class="selection-option non-tip"
                        [color]="this.selectedTip === 'CUSTOM' ? 'primary' : 'tertiary'"
                        (click)="clickCustom()">
                <div class="option-container">
                    <span>Custom</span>
                </div>
            </ion-button>
        </ion-col>
        <ion-col size-xs="6">
            <ion-button class="selection-option non-tip"
                        [color]="this.selectedTip === 'NO_TIP' ? 'primary' : 'tertiary'"
                        (click)="changedSelected('NO_TIP')">
                <div class="option-container">
                    <span>No Tip</span>
                </div>
            </ion-button>
        </ion-col>
    </ion-row>
</ion-grid>
<ion-item *ngIf="!hideTip" lines="none">
    <ion-grid>
        <ion-row class="tip-info">
            <ion-col size-xs="8" size-sm="8" size-md="9" class="ion-text-end">
                Tip:
            </ion-col>
            <ion-col class="ion-text-end child">
                {{tipValue | currency}}
            </ion-col>
        </ion-row>
    </ion-grid>
</ion-item>
